export default __webpack_public_path__ + "static/media/warehouseico.b9cd35d9.png";